<div class="mt-7">
  <!-- Normal List View -->
  <div class="bg-white rounded-md shadow-sm border divide-y">

    @if (systemFormData && systemFormData.length > 0) {
      <div>
        <!-- only take the first record -->
        @if (systemFormData[0]; as item) {
          <div
            class="grid grid-cols-2 items-center px-4 py-3 border-b hover:bg-gray-50 text-sm">
            <input type="hidden" [value]="item.id" />
            <!-- Left Section -->
            <div class="flex items-center gap-3">
              <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -- pre-existing pattern; accessibility tracked under COL-37 -->
              <div class="font-medium text-gray-900 cursor-pointer text-primary hover:underline"
                (click)="onSystemFormClick(item)">
                {{ item.templateId > 0 ? item.template : templateName }}
              </div>
            </div>
            <!-- Right Section -->
            <!-- <div class="flex justify-end gap-2">
            <button mat-icon-button color="warn" (click)="onDeleteSystemForm(item)">
              <mat-icon svgIcon="c:trash"></mat-icon>
            </button>
          </div> -->
        </div>
      }
    </div>
  } @else {
    <div class="px-4 py-6 text-center text-gray-500">
      No system form found
    </div>
  }

  <!-- No Data Template -->
</div>
</div>